import { Heading } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { FinancialStatus } from '../adminProcessFinancials/FinancialStatus';

type FinancialSectionProps = {
    processNumber: number;
};

export function FinancialSection({ processNumber }: FinancialSectionProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Heading
                mb={6}
                size="large"
            >
                {translate.processDetails.financialStatus}
            </Heading>
            <FinancialStatus
                hasCard={true}
                invoiceRecords={[]}
                processNumber={processNumber}
            />
        </>
    );
}
